import styles from "./NotFound.module.css";

function NotFound() {
    return (
        <div className={styles.txt}> Not Found </div>
    );
}

export default NotFound;
